// Position level mappings based on title keywords
export const POSITION_LEVELS = {
  CEO: 6,
  HEAD: 6,
  PRINCIPAL: 5,
  STAFF: 4,
  SENIOR: 3,
  SPECIALIST: 3,
  MID: 2,
  JUNIOR: 1,
};

// Communication frequency options from Compensation Partner
export const COMMUNICATION_FREQUENCY = {
  VERY_LITTLE: "Sehr wenig (typischerweise weniger als 15% der Arbeitszeit)",
  LITTLE: "Wenig (typischerweise weniger als 40% der Arbeitszeit)",
  MUCH: "Viel (typischerweise mehr als 40% der Arbeitszeit)",
  DOMINANT: "Kommunikation als prägender Stelleninhalt (typischerweise mehr als 75% der Arbeitszeit)"
};

// Communication scope options
export const COMMUNICATION_SCOPE = {
  INDIVIDUAL: "mit Einzelpersonen (90 % der Kommunikation)",
  SMALL_GROUP: "aktive Ansprache von min. 3 Personen zu mehr als 10 % der Kommunikation",
  DEPARTMENT: "Steuerung durch Kommunikation von 10 bis 20 Personen (z.B. Abteilungsleitung)",
  PUBLIC: "vor Publikum (monatliche Vorträge vor mehr als 30 Personen)"
};

// Communication style options
export const COMMUNICATION_STYLE = {
  FACTUAL: "überwiegend auf der Sachebene",
  MOTIVATING: "überwiegend motivierend / überzeugend",
  INSPIRING: "Kommunikation ausgeprägt gewinnend, inspirierend, überzeugend und motivierend, Änderungsbereitschaft erzeugend"
};

// Cultural communication options
export const COMMUNICATION_CULTURE = {
  NATIONAL: "national",
  MIXED: "Zwischenstufe zwischen national und international",
  INTERNATIONAL: "international / länder- und/oder kulturübergreifend (mehr als 10% der Kommunikation)"
};

// Strategic influence levels
export const STRATEGIC_INFLUENCE = {
  ONLY_OPERATIONAL: "führt nur operative Tätigkeiten aus bzw. löst nur Routineaufgaben",
  MOSTLY_OPERATIONAL: "führt meist operative Tätigkeiten aus bzw. löst fast nur Routineaufgaben",
  OPERATIONAL_WITH_STRATEGIC: "führt in der Regel operative Tätigkeiten aus, manchmal sind die Ergebnisse Basis strategischer Entscheidungen",
  MIXED: "führt sowohl operative als auch strategische Tätigkeiten aus",
  MOSTLY_STRATEGIC: "bearbeitet meist strategische Probleme oder ist oft daran beteiligt",
  ONLY_STRATEGIC: "bearbeitet praktisch ausschließlich strategische Probleme"
};

// Result visibility timeframes
export const RESULT_VISIBILITY = {
  IMMEDIATE: "sofort",
  DAYS: "nach Tagen",
  WEEKS: "nach Wochen",
  MONTHS: "nach Monaten",
  YEAR: "in einem Jahr",
  YEARS: "nach Jahren"
};

// Quality control difficulty
export const QUALITY_CONTROL = {
  VERY_EASY: "sehr leicht kontrolliert werden",
  EASY: "mit wenig Aufwand kontrolliert werden",
  DIFFICULT: "mit großem Aufwand kontrolliert werden",
  KPI_BASED: "nur anhand von Kenngrößen beurteilt werden",
  EXPERIENCE_BASED: "nur anhand von Erfahrungen qualitativ auf Plausibilität abgeschätzt werden",
  RESULT_BASED: "nur anhand der späteren Ergebnisse als gut oder schlecht beurteilt werden"
};

// Personnel responsibility types
export const PERSONNEL_RESPONSIBILITY = {
  NONE: "Keine Personalverantwortung",
  TECHNICAL: "Fachliche Mitarbeiterführung",
  DISCIPLINARY: "Disziplinarische Mitarbeiterführung",
  EXECUTIVE: "Geschäftsführung"
};

// Education levels
export const EDUCATION_LEVELS = {
  AUSBILDUNG: "Ausbildung",
  BACHELOR: "Bachelor (Uni, FH, BA)",
  MASTER: "Master / Diplom",
  PHD: "Promotion"
};

// Experience levels
export const EXPERIENCE_LEVELS = {
  MONTHS_6: "6 Monate",
  YEARS_1_2: "1 - 2 Jahre",
  YEARS_3_5: "3 - 5 Jahre",
  YEARS_6_8: "6 - 8 Jahre",
  YEARS_9_12: "9 - 12 Jahre",
  YEARS_12_PLUS: "über 12 Jahre"
};

// Team size ranges
export const TEAM_SIZE = {
  SMALL: "1 - 3",
  MEDIUM: "4 - 8",
  LARGE: "9 - 15",
  XLARGE: "16 - 30",
  XXLARGE: "über 30"
};